/* jshint esversion: 6 */
import {createRouter, createWebHashHistory} from "vue-router";

import Index from '../views/Index.vue';
import Company from '../views/Company.vue';
import Price from '../views/Price.vue';
import Wall from '../views/Wall.vue';
import Garden from '../views/Garden.vue';
import Green from '../views/Green.vue';
import Products from '../views/Products.vue';

import Projects from '../views/Projects.vue';

import Contact from '../views/Contact.vue';

const routes = [
    {
        path: "/",
        name: Index,
        component: Index,
        meta: {
            title: "首页"
        }
    },
    {
        path: "/index",
        name: Index,
        component: Index
    },
    {
        path: "/company",
        name: Company,
        component: Company
    },
    {
        path: "/price",
        name: Price,
        component: Price
    },
    {
        path: "/wall",
        name: Wall,
        component: Wall
    },
    {
        path: "/garden",
        name: Garden,
        component: Garden
    },
    {
        path: "/green",
        name: Green,
        component: Green
    },
    {
        path: "/products",
        name: Products,
        component: Products
    },
    {
        path: "/projects",
        name: Projects,
        component: Projects
    },

    {
        path: "/contact",
        name: Contact,
        component: Contact
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,

});

export default router;
